import {Injectable} from '@angular/core';
import { UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';

@Injectable()
export class FormValidationService {
    public include(form: UntypedFormGroup, controlName: string, validators: ValidatorFn[]) {
        form.get(controlName).setValidators(Validators.compose(validators));
        form.get(controlName).updateValueAndValidity();
    }
    public exclude(form: UntypedFormGroup, controlName: string) {
        form.get(controlName).clearValidators();
        form.get(controlName).clearAsyncValidators();
        form.get(controlName).setErrors(null);
        form.get(controlName).updateValueAndValidity();
    }
}
